import { Component, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import * as moment from "moment-timezone";
import { TripStoreService } from 'src/app/itineries/services/store/trip-store/trip-store.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { statuses } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-horizontal-bar-chart',
  templateUrl: './horizontal-bar-chart.component.html',
  styleUrls: ['./horizontal-bar-chart.component.css']
})
export class HorizontalBarChartComponent implements OnInit {

  timeZone: any;
  user: any;

  // Bar chart properties
  barChartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  barChartLabels = statuses;
  barChartType = 'horizontalBar' as const;
  barChartLegend = false;
  dataSets;

  constructor(
    private sharedDataService: SharedDataService,
    private tripStoreService: TripStoreService,
  ) { }

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;
          this.prepareData();
        }
      });
  }

  prepareData() {
    this.tripStoreService.state$.subscribe((res) => {
      if (res) {
        this.calculateStats(res);
      }
    }
    );
  }

  calculateStats(trips) {
    if (!trips.list.length) {
      this.dataSets = null;
      return;
    }

    const statusMap = {
      willCall: 0,
      pending: 0,
      onway: 0,
      arrived: 0,
      InVehicle: 0,
      exiting: 0,
      canceled: 0,
      rode: 0
    };




    for (const { jobStatus, status, changeReason, scheduleTime } of trips.list) {

      const orignalTime = moment(scheduleTime).tz(this.timeZone);
      const specificTime = moment().tz(this.timeZone).hour(22).minute(0).second(0).millisecond(0);

      if ( moment(orignalTime.format('HH:mm:ss'), 'HH:mm:ss').tz(this.timeZone).isSameOrAfter(specificTime)) {
        statusMap.willCall++;
      } else if (['marketplaced','pending', 'offered', 'accepted'].includes(status)) {
        statusMap.pending++;
      } else if (jobStatus === 'onway') {
        statusMap.onway++;
      } else if (jobStatus === 'arrived') {
        statusMap.arrived++;
      } else if (jobStatus === 'started') {
        statusMap.InVehicle++;
      } else if (jobStatus === 'completed') {
        statusMap.exiting++;
      } else if (jobStatus === 'cancelled') {
          statusMap.canceled++;
      } else if (jobStatus === 'finished') {
        statusMap.rode++;
      }
    }

    this.dataSets = [{
      data: [
        statusMap.willCall,
        statusMap.pending,
        statusMap.onway,
        statusMap.arrived,
        statusMap.InVehicle,
        statusMap.exiting,
        statusMap.canceled,
        statusMap.rode
      ],
      label: 'Trips'
    }];


  }

  ngOnDestroy(): void {
  }

}
